<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-row>
      <b-col>
        <b-form @submit="onSubmit" @reset="onReset">
          <b-row class="justify-content-md-center">
            <b-col class="mt-2">
              <p class="reg-heading-tab mb-3">Add New Disbursal</p>
              <div class="reg-tab-container mb-3">
                <b-row>
                  <b-col md="3"><b style="font-size:14px">Bank Name:</b></b-col><b-col style="font-size:14px">{{LoanDetails.BankName}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3"> <b style="font-size:14px">Branch Name:</b></b-col><b-col style="font-size:14px">{{LoanDetails.BranchName}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3"><b style="font-size:14px">Approved Amount:</b></b-col><b-col>&#8377;{{LoanDetails.SanctionAmount}}</b-col>
                   <b-col  md="3"><b style="font-size:14px">Disbursed Amount:</b></b-col><b-col md="3">&#8377;{{TotalDisbursementAmount}}</b-col>
                </b-row>
                <b-row>
                  <b-col  md="3" style="font-size:14px"><b>Interest Rate %:</b></b-col><b-col md="3" style="font-size:14px">{{LoanDetails.ROI}}</b-col>

                  <b-col  md="3" style="font-size:14px"><b>Tenure (months):</b></b-col><b-col md="3" style="font-size:14px">{{LoanDetails.LoanTenure}}</b-col>
                </b-row>
              </div>
              <div class="reg-tab-container">
                <b-form-group id="igrp0" label="Disbursal Date*"  label-cols="4" label-size="sm">
                  <b-form-input
                    type="date"
                    placeholder="Disbursal Date*"
                    size="sm"
                    lazy-formatter
                    v-model="form.DisbursalDate"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="igrp0" label="Loan Tenure (Months)*"  label-cols="4" label-size="sm">
                  <b-form-input
                    type="number"
                    placeholder="Total Installments to be paid"
                    size="sm"
                    lazy-formatter
                    v-model="form.LoanTenure"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="igrp1" label="EMI Start Date*"  label-cols="4" label-size="sm">
                  <b-form-input
                    type="date"
                    placeholder="Start Date"
                    size="sm"
                    v-model="form.EmiStartDate"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="igrp2" label="EMI End Date"  label-cols="4" label-size="sm">
                  <b-form-input
                    type="date"
                    placeholder="End Date"
                    size="sm"
                    required
                    v-model="form.EmiEndDate"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="igrp3"
                  horizontal
                  label="Disbursed Amount (Rs)*" label-cols="4"
                  label-size="sm"
                  label-for="inpAmount"
                >
                  <b-form-input
                    id="inpAmount"
                    type="number"
                    v-model="form.DisburmentAmount"
                    required
                    size="sm"
                    :min="minAmount"
                    :max="LoanDetails.SanctionAmount"
                    placeholder="Disbursed Amount"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="igrp6" label="EMI Amount (Rs)*"  label-cols="4" label-size="sm">
                  <b-form-input
                    type="text"
                    placeholder="EMI Amount Rs"
                    size="sm"
                    required
                    :formatter="format"
                    lazy-formatter
                    v-model="form.EmiAmount"
                  ></b-form-input>
                </b-form-group>
                <div class="row">
                  <div class="col-md-4">
                    <span
                      class="ln-eng"
                      style="font-size: 0.875rem;"
                    >Disbursal Letter *</span>
                    <p style="font-size: 0.75rem;color:#2284ab;">Upload All pages of Disbursal Letter</p>
                  </div>
                  <div class="col-md-4">
                    <b-form-file
                      ref="fiPhotoPath"
                      @change="onFileChange"
                      v-if="form.UploadDisburmentLetter =='' || !form.UploadDisburmentLetter"
                      accept=".jpg, .png, .gif, .pdf"
                      size="sm"
                      required
                      class="mt-3"
                      plain
                    ></b-form-file>
                  </div>
                  <div class="col-md-4" v-if="form.UploadDisburmentLetter!='' && form.UploadDisburmentLetter">
                    <a :href="getImgUrl2(form.UploadDisburmentLetter)" target="_blank">
                      <img style="height:30px" :src="getImgUrl(form.UploadDisburmentLetter)" class="img-fluid">
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('sanctionLetter', form.UploadDisburmentLetter)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                      v-if="!LockProfile"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <span
                      class="ln-eng"
                      style="font-size: 0.875rem;"
                    >Bank Repayment Schedule *</span>
                    <p style="font-size: 0.75rem;color:#2284ab;">Upload Bank Repayment Schedule (required to generate EMI)</p>
                  </div>
                  <div class="col-md-4">
                    <b-form-file
                      ref="fiBankRepayment"
                      @change="onBankRepaymentFileChange"
                      v-if="form.UploadBankStatement =='' || !form.UploadBankStatement"
                      accept=".jpg, .png, .gif, .pdf"
                      size="sm"
                      required
                      class="mt-3"
                      plain
                    ></b-form-file>
                  </div>
                  <div class="col-md-4" v-if="form.UploadBankStatement!='' && form.UploadBankStatement">
                    <a :href="getImgUrl2(form.UploadBankStatement)" target="_blank">
                      <img style="height:30px" :src="getImgUrl(form.UploadBankStatement)" class="img-fluid">
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('bankRepayment', form.UploadBankStatement)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                      v-if="!LockProfile"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2 justify-content-md-center" v-if="!getUserData.LockProfile">
            <b-col md="4" sm="12" style="text-align:center">
              <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
              <b-alert
                :show="showDismissibleAlert"
                dismissible
                @dismissed="showDismissibleAlert=false"
                :variant="variant"
              >{{alertText}}</b-alert>
            </b-col>
            <b-col sm="12" style="text-align:right">
              <b-button type="submit" style="float:right" class="ml-3" variant="primary">Submit</b-button>
              <b-button type="reset" style="float:right" variant="danger">Reset</b-button>
              <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
      <b-col>
        <p class="reg-heading-tab mb-3">EMI Schedule</p>
        <b-table
          show-empty
          selectable
          select-mode="multi"
          head-variant="dark"
          empty-text="No Applications available."
          stacked="md"
          bordered
          striped
          :items="emiList"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          @row-selected="onRowSelected"
          style="font-size:12px">
          <template v-slot:cell(SL)="row">
            <span aria-hidden="true">{{row.index+1+(10*(currentPage-1))}}</span>
          </template>
        </b-table>
        <b-row>
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
              <b-form-select :options="pageOptions" v-model="perPage" size="sm"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import common from "@/apis/common";
import Formatter from "@/Formatter";

export default {
  components: { Spinner },
  data() {
    return {
      emiList: [],
      fields: [
        { key: "SL", label: "Sr No" },
        { key: "EMIDate", label: "Month", formatter:"convertDateFormat" },
        { key: "EMIAmount", label: "EMI" },
        { key: "OpeningBalance", label: "Opening Amount" },
        { key: "PrincipalAmount", label: "Principal" },
        { key: "InterestAmount", label: "Interest" },
        { key: "ClosingBalance", label: "Balance" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      minAmount: 10000,
      maxAmount: 1000000,
      Photo: "",
      form: {
        LoanDisbursementID: "00000000-0000-0000-0000-000000000000",
        LoanSanctionID: "",
        LoanTenure: 0,
        UpdatedBy: "",
        DisbursalDate: null,
        EmiStartDate: null,
        EmiEndDate: null,
        VerifiedStatus: 0,
        TrancheNo: 0,
        SeparateTenure: false,
        DisburmentAmount: 0,
        EmiAmount: 0,
        HOApprovedAmount: 0,
        UploadDisburmentLetter: "",
        UploadBankStatement: ""
      },
      LockProfile: false,
      saved: false,
      LockProfile: false,
      dt: null,
      TotalDisbursementAmount: 0,
      BankRepaymentPhoto: null
    };
  },
  watch: {
    // "form.DisburmentAmount"(newval){
    //   TotalDisbursementAmount = Number(LoanDetails) + Number(newval);
    // },
    "form.EmiStartDate"(newval) {
      if (this.form.LoanTenure > 0) {
        let dtl = new Date(newval);

        let n = this.form.LoanTenure - 1;
        dtl.setMonth(dtl.getMonth() + n);
        this.form.EmiEndDate = this.formatDate(dtl);
      }
    },
    "form.LoanTenure"(newval) {
      if (this.form.EmiStartDate != null) {
        let dtl = new Date(this.form.EmiStartDate);

        let n = newval - 1;
        dtl.setMonth(dtl.getMonth() + n);
        this.form.EmiEndDate = this.formatDate(dtl);
      }
    }
  },
  computed: {
    LoanDetails() {
      return this.$store.getters.getSanctionLetter;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    convertDateFormat(inDate) {
      return (Formatter.convertDateFormat(inDate));
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        LoanDisbursementID: "00000000-0000-0000-0000-000000000000",
        LoanSanctionID: "",
        UpdatedBy: "",
        DisbursalDate: null,
        EmiStartDate: null,
        EmiEndDate: null,
        VerifiedStatus: 1,
        TrancheNo: 0,
        SeparateTenure: false,
        DisburmentAmount: 0,
        EmiAmount: 0,
        HOApprovedAmount: 0,
        UploadDisburmentLetter: "",
        UploadBankStatement: ""
      };
      this.BankRepaymentPhoto = null;
    },
    async onSubmit(evt) {
      evt.preventDefault();
      if (
        Number(this.LoanDetails.SanctionAmount) <
        Number(this.TotalDisbursementAmount) +
          Number(this.form.DisburmentAmount)
      ) {
        this.alertText =
          "Total Disbursement can't be more than Approved value.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        return;
      }
      this.showDismissibleAlert = false;
      this.isLoading = true;

      // Validate bank repayment schedule is uploaded
      if (!this.BankRepaymentPhoto && !this.form.UploadBankStatement) {
        this.alertText = "Please upload Bank Repayment Schedule to generate EMI schedule.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      var d = new Date();
      let response = await common.onFileChange(
        this.Photo,
        "DisbursalLetter_" + d * 1 + "."
      );
      if (response.status) {
        this.form.UploadDisburmentLetter = response.message;
      } else {
        this.$refs.fiPhotoPath.reset();
        this.alertText = response.message;
        this.variant = "danger";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      // Upload bank repayment schedule
      if (this.BankRepaymentPhoto) {
        let repayResponse = await common.onFileChange(
          this.BankRepaymentPhoto,
          "BankRepaymentSchedule_" + d * 1 + "."
        );
        if (repayResponse.status) {
          this.form.UploadBankStatement = repayResponse.message;
        } else {
          this.$refs.fiBankRepayment.reset();
          this.alertText = repayResponse.message;
          this.variant = "danger";
          this.showDismissibleAlert = true;
          this.isLoading = false;
          return;
        }
      }

      var userinfo = this.$store.getters.loggedUser;
      this.form.UpdatedBy = userinfo.UserId;
      this.form.LoanSanctionID = this.LoanDetails.LoanSanctionID;

      let promise = apis.saveDisbursement(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.form.LoanDisbursementID = response.body[0].LoanDisbursementID;
            this.emiList = response.body;
            this.totalRows = this.emiList.length;
            this.LoanDetails.DisbursementAmount =
              Number(this.atStartDisbursementAmount) +
              Number(this.form.DisburmentAmount);
            this.alertText = "Data Saved Successfully";
            this.isSaved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      // let scheduleInput = {
      //   LoanAmount: this.form.DisburmentAmount,
      //   InterestRate: this.LoanDetails.ROI,
      //   Tenure: this.form.LoanTenure,
      //   StartDate: this.form.EmiStartDate
      // };

      // let promiseEmi = apis.getSehedule(scheduleInput);
      // promiseEmi.then(rspn => {
      //   console.log(rspn);
      //   if (rspn.status == 200) {
      //     this.emiList = rspn.body;
      //     this.totalRows = this.emiList.length;
      //   }
      // });
    },
    getUserData() {},
    async onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.Photo = files;
    },
    async onBankRepaymentFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.BankRepaymentPhoto = files;
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      let promise = apis.saveLoanDocumentPath(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            if (this.docTbl.length > 0) {
              this.loadLoanImageList();
            }
            this.$refs.fiPhotoPath.reset();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    deleteDocument2(document, path) {
      //console.log(item);
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    }
  },
  mounted() {
    this.TotalDisbursementAmount = this.$store.getters.getSanctionLetter.DisbursementAmount;
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/LoanDisbursal/UploadDisbursal.vue